import { axiosGet } from '@/app/helpers/AxiosHelper';

export default {
  state: {
    id: null,
    app: null,
    org: null,
    bank: [],
    transactionType: [],
    cantons: [],
    responsible: [],
    accAppOptions: {
      accreditationAreas: [],
      accreditationActivities: [],
      accreditationTypes: [],
      status: [],
    },
    evaluationDataOptions: {
      evaluationPlace: [],
      entityType: [],
      trialsEntity: [],
    },
    typeStaff: [],
    tree: [],
    currentStatus: null,
    expired_license: {},
    license_id:null,
  },

  mutations: {
    SET_BANK(state, { data }) {
      state.bank = data;
    },
    SET_TRANSACTION_TYPE(state, { data }) {
      state.transactionType = data;
    },
    SET_RESPONSIBLE(state, data) {
      state.responsible = data;
    },
    SET_APP(state, data) {
      state.app = data;
    },
    SET_APP_OPTIONS(state, data) {
      state.accAppOptions = data;
    },
    SET_EVALUATION_DATA_OPTIONS(state, data) {
      state.evaluationDataOptions = data.options;
    },
    SET_TYPE_STAFF(state, data) {
      state.typeStaff = data;
    },
    SET_TREE(state, data) {
      state.tree = data;
    },
    SET_LICENSE(state, data) {
      state.expired_license = data;
    },
  },

  actions: {
    getSendRequestOptions({ commit, state }) {
      let url;
      // if (state.bank.length == 0) {
      url = '/masterdata/banks/index?is_active=1`';
      axiosGet(url).then(res => {
        if (res.status == 200) {
          commit('SET_BANK', res.data);
        }
      });
      // }

      if (state.transactionType.length == 0) {
        url = '/masterdata/transactiontypes/index';
        axiosGet(url).then(res => {
          if (res.status == 200) {
            commit('SET_TRANSACTION_TYPE', res.data);
          }
        });
      }

    },

    getResponsible({ commit, state }) {
      if (state.responsible.length == 0) {
        const url = '/details/responsable';
        axiosGet(url).then(res => {
          if (res.status == 200) {
            commit('SET_RESPONSIBLE', res.data);
          }
        });
      }
    },

    getAccApp({ commit, state }) {
      const url = `/accreditations/applications/form/${state.id}`;
      axiosGet(url).then(res => {
        if (res.status == 200) {
          commit('SET_APP', res.data);
        }
      });
    },

    getAccAppOptions({ commit, state }) {
      const url = '/accreditations/applications/options';
      axiosGet(url).then(res => {
        if (res.status == 200) {
          commit('SET_APP_OPTIONS', res.data);
        }
      });
    },

    getEvaluationDataOptions({ commit, state }) {
      let url = `/organizations/evaluationData/options?accAppId=${state.id}`;
      axiosGet(url).then(res => {
        if (res.status == 200) {
          commit('SET_EVALUATION_DATA_OPTIONS', res.data);
        }
      });
    },

    getLaboratoryStaffOptions({ commit, state }) {
      let url = `/details/laboratoryStaff/options`;
      axiosGet(url).then(res => {
        if (res.status == 200) {
          commit('SET_TYPE_STAFF', res.data);
        }
      });
    },

    getScopeTreeByActivity({ commit, state }) {
      let url = `/scopes/treeByActivity?accAppId=${state.id}`;
      if (state.tree.length == 0) {
        axiosGet(url).then(res => {
          if (res.status == 200) {
            commit('SET_TREE', res.data);
          }
        });
      }
    },

    getExpiredLicense({commit}, data) {
      const url = `/accreditations/process/emailNotifyAccessAcc/${data}`;
          axiosGet(url).then(res => {
          });
    },
  }
}